<div class="message" *ngIf="subscription.loaded && subscription.low_profile_id">

  <!--      <h1>קיימת השתתפות עד תאריך {{subscription.expiry_date}}</h1>-->
<!--  <h2>קיימת השתתפות עד לתאריך (סוף יום) {{ subscription.expiry_date | date:'shortDate' }}</h2>-->
  <h2>{{ 'PAYMENT.SUBSCRIPTION_SUCCESS' | translate }}</h2>
</div>


<div class="wrapper-spinner" *ngIf="loading">
  <mat-spinner></mat-spinner>
</div>

<div class="wrapper" *ngIf="subscription.loaded && subscription.error">
  <div class="pricing-table gprice-single">
    <div class="head">
      <h4 class="title">{{ 'PAYMENT.MONTHLY_PLAN' | translate }}</h4>
    </div>
    <div class="content">
      <div class="price">
        <h1>550 ₪</h1>
      </div>
      <ul>
        <li>{{ 'PAYMENT.CALCULATOR_USAGE_DESC' | translate }}</li>
        <li>{{ 'PAYMENT.DAILY_NEW_CARS_ACCESS' | translate }}</li>
        <li>{{ 'PAYMENT.MONTHLY_AUTO_RENEW' | translate }}</li>
        <li><b>{{ 'PAYMENT.PRICE_BEFORE_VAT' | translate }}</b></li>

      </ul>
      <div class="terms-container">
        <input type="checkbox" [(ngModel)]="termsAccepted" id="termsMonthly">
        <label for="termsMonthly">{{ 'PAYMENT.TERMS_AGREEMENT_PREFIX' | translate }}</label>
        <button mat-button (click)="openDialog()">{{ 'PAYMENT.TERMS_OF_SERVICE' | translate }}</button>
      </div>
      <div class="sign-up">
        <button mat-raised-button color="primary" class="btn bordered radius" [disabled]="!termsAccepted" (click)="signupMonthly()">{{ 'PAYMENT.SIGN_UP_NOW' | translate }}
        </button>
        <!--        <a href="#" class="btn bordered radius" (click)="signupMonthly()">הירשמו עכשו</a>-->
      </div>
    </div>
  </div>
  <div class="pricing-table gprice-single">
    <div class="head">
      <h4 class="title">{{ 'PAYMENT.ANNUAL_PLAN' | translate }}</h4>
    </div>
    <div class="content">
      <div class="price">
        <h1>6000 ₪</h1>
      </div>
      <ul>
        <li>{{ 'PAYMENT.CALCULATOR_USAGE_DESC' | translate }}</li>
        <li>{{ 'PAYMENT.DAILY_NEW_CARS_ACCESS' | translate }}</li>
        <li>{{ 'PAYMENT.ANNUAL_ACCESS_COST_DESC' | translate }}</li>
        <li><b>{{ 'PAYMENT.PRICE_BEFORE_VAT' | translate }}</b></li>
      </ul>
      <div class="terms-container">
        <input type="checkbox" [(ngModel)]="termsAccepted" id="termsAnnual">
        <label for="termsAnnual"> {{ 'PAYMENT.TERMS_AGREEMENT_PREFIX' | translate }}</label>
        <button mat-button (click)="openDialog()">{{ 'PAYMENT.TERMS_OF_SERVICE' | translate }}</button>
      </div>
      <div class="sign-up">
        <button mat-raised-button color="primary" class="btn bordered radius" [disabled]="!termsAccepted" (click)="signupAnnual()">{{ 'PAYMENT.SIGN_UP_NOW' | translate }}
        </button>
        <!--        <button class="btn bordered radius" (click)="signupAnnual()">הירשמו עכשו</a>-->
      </div>
    </div>
  </div>
</div>
<!--<iframe *ngIf="succeededRetrieval" [src]="iframeUrl"-->
<!--        width="100%" height="100%" scrolling="no" frameborder="0">-->
<!--</iframe>-->
